import React from 'react';
import { Card, CardContent } from './card';
import { FileText, GraduationCap, Rocket } from 'lucide-react';

export const HowItWorksSection = () => {
  const steps = [
    {
      step: "01",
      icon: FileText,
      title: "Apply for Your Franchise",
      description: "Submit your application and schedule a consultation with our franchise development team."
    },
    {
      step: "02", 
      icon: GraduationCap,
      title: "Receive Training & Support",
      description: "Complete our comprehensive training program and receive ongoing operational support."
    },
    {
      step: "03",
      icon: Rocket,
      title: "Launch & Grow Your Business",
      description: "Open your salon with our proven systems and start building your successful franchise."
    }
  ];

  return (
    <section className="py-24 bg-cream">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="section-title text-5xl md:text-6xl font-bold mb-6 text-dark">
            How It Works
          </h2>
          <p className="text-xl text-subtle">Your path to salon ownership in 3 simple steps</p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 relative">
          {/* Connection lines */}
          <div className="hidden md:block absolute top-1/2 left-1/3 w-1/3 h-0.5 bg-accent-primary/30 transform -translate-y-1/2"></div>
          <div className="hidden md:block absolute top-1/2 right-1/3 w-1/3 h-0.5 bg-accent-primary/30 transform -translate-y-1/2"></div>
          
          {steps.map((step, index) => (
            <Card key={index} className="step-card group hover:shadow-xl transition-all duration-300 relative z-10 bg-white">
              <CardContent className="p-8 text-center">
                <div className="step-number text-6xl font-bold text-accent-primary/20 mb-4 group-hover:text-accent-primary/40 transition-colors duration-300">
                  {step.step}
                </div>
                
                <div className="step-icon w-16 h-16 bg-accent-primary rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                  <step.icon className="w-8 h-8 text-white" />
                </div>
                
                <h3 className="text-xl font-bold mb-4 text-dark">{step.title}</h3>
                <p className="text-subtle leading-relaxed">{step.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};